import CustomError from 'utils/CustomError';

export const createErrorFromAxiosUserMessageError = error => {
  if (error.response && typeof error.response.data === 'object') {
    const message = error.response.data.errors[0];
    return new Error(message);
  }
  return new Error(error.message);
};

export const createErrorFromAxiosMultipleErrors = (error, info = {}) => {
  if (error.response && typeof error.response.data === 'object') {
    const messages = error.response.data.errors;
    return new CustomError(messages, info);
  }
  return new CustomError([error.message], info);
};
